var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { WidgetContent } from '../WidgetContent';
import { TemplateKind } from '../../Model/TemplateKind';
import { Templater } from '../../Template/Templater';
import { TemplateMode } from '../../Model/TemplateMode';
import { HtmlUtil } from '../../Util/HtmlUtil';
import { SliderState } from '../../Model/SliderState';
import { TrackerFactory } from '../../Factory/TrackerFactory';
import { WidgetType } from '../../Model/WidgetType';
import { ExperimentSegment } from '../../Analytics/ExperimentSegment';
import { DeviceUtil } from '../../Util/DeviceUtil';
var SlideDirection;
(function (SlideDirection) {
    SlideDirection["Left"] = "left";
    SlideDirection["Right"] = "right";
})(SlideDirection || (SlideDirection = {}));
var BUTTON_WIDTH = '80px';
var BUTTON_OPENED_WIDTH = '256px';
var SLIDER_WIDTH = 'calc(100% - 16px)';
var SliderWidgetContent = /** @class */ (function (_super) {
    __extends(SliderWidgetContent, _super);
    function SliderWidgetContent(widget, behavior) {
        var _this = _super.call(this) || this;
        _this._dynamicStyles = [];
        _this._lastSlideIndex = 0;
        _this._currentSlideIndex = 0;
        _this._sliderOpened = false;
        _this._needButtonAnimation = true;
        _this._tracker = TrackerFactory.getTracker();
        _this._isOtaPriceCompareSWActivated = false;
        _this._cashbackIndex = undefined;
        _this.removedPriceCompareWidget = null;
        _this._widget = widget;
        _this._behavior = behavior;
        _this._slides = (widget.slides || []).slice(0, 7);
        return _this;
    }
    Object.defineProperty(SliderWidgetContent.prototype, "sort", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SliderWidgetContent.prototype, "widgetKey", {
        get: function () {
            return this._slides[this._currentSlideIndex] && this._slides[this._currentSlideIndex].widgetKey || null;
        },
        enumerable: false,
        configurable: true
    });
    SliderWidgetContent.prototype.getProviderId = function () {
        return this._slides
            .map(function (widget) { return widget.getProviderId(); })
            .filter(function (value, index, self) { return self.indexOf(value) === index; })
            .join(',');
    };
    SliderWidgetContent.prototype.canShow = function () {
        return this._widget.content ? !!this._widget.content.text : true;
    };
    SliderWidgetContent.prototype.trackEvent = function (eventName) {
        var data = {
            action: eventName,
            provider: this.getProviderId()
        };
        if (eventName !== 'preview') {
            data = Object.assign(data, {
                amount: this._slides.length,
                number: this._currentSlideIndex + 1,
                widgetKey: this.widgetKey
            });
        }
        // HYPONLINE-91
        if (this._isOtaPriceCompareSWActivated) {
            var pcData = Object.assign({}, data, {
                segment: this.getOtaPriceCompareSegment(),
                layout: DeviceUtil.isMobile() ? 'phone' : 'desktop'
            });
            var isInOldSegment = pcData.segment !== 'new';
            pcData.amount = isInOldSegment ? this._slides.length + 1 : this._slides.length;
            if (isInOldSegment && eventName === 'preview' && !!this.removedPriceCompareWidget) {
                pcData.provider = this.removedPriceCompareWidget.getProviderId();
            }
            var needSkipEvents = isInOldSegment && ((DeviceUtil.isMobile() && eventName !== 'preview') || (!DeviceUtil.isMobile() && eventName !== 'show'));
            if (!needSkipEvents) {
                if (eventName === 'show') {
                    var widgetContent = this.removedPriceCompareWidget === null
                        ? this._slides[this._currentSlideIndex].widget.widgetContent
                        : this.removedPriceCompareWidget.widget.widgetContent;
                    var bfPrice = parseInt(widgetContent.minBookingFormPrice.replace(/\D/g, ''), 10);
                    var otaPrice = parseInt(widgetContent.minOtaPrice.replace(/\D/g, ''), 10);
                    pcData.priceDifference = otaPrice - bfPrice;
                }
                this._tracker.event('ota-price-compare', pcData);
            }
        }
        this._tracker.event('smart-widget', data);
    };
    SliderWidgetContent.prototype.render = function (templateKind, templateMode, submitCb, hideCb, resizeCb) {
        var _this = this;
        var template = document.createElement('template');
        var container = document.createElement('div');
        container.style.display = 'inline-block';
        template.appendChild(container);
        this._isOtaPriceCompareSWActivated = this._slides.length
            ? this._slides[0].widgetKey === '25a6b616-dd8e-46d8-9fa1-5893dc343e42'
            : false;
        var segment = this.getOtaPriceCompareSegment();
        if (this._isOtaPriceCompareSWActivated && segment !== 'new') {
            this.removedPriceCompareWidget = this._slides.splice(0, 1)[0];
        }
        if (templateKind === TemplateKind.Slider) {
            this.type = WidgetType.Slider;
            this.createSlider(container, templateMode, resizeCb, hideCb);
            // После добавления в DOM
            setTimeout(function () {
                _this.setSliderHeight();
                _this.trackEvent('show');
            });
        }
        else if (templateKind === TemplateKind.Mobile) {
            this.type = WidgetType.Button;
            this._buttonElement = this.createButton(container, resizeCb);
        }
        return template;
    };
    SliderWidgetContent.prototype.getCashbackWidgetIndex = function () {
        var _a;
        if (this._cashbackIndex !== undefined) {
            return this._cashbackIndex;
        }
        this._cashbackIndex = -1;
        if (this._slides && this._slides.length > 0) {
            for (var i = 0; i < this._slides.length; ++i) {
                if (((_a = this._slides[i].widget) === null || _a === void 0 ? void 0 : _a.type) === WidgetType.Cashback) {
                    this._cashbackIndex = i;
                    break;
                }
            }
        }
        return this._cashbackIndex;
    };
    SliderWidgetContent.prototype.getSourceNameForPriceCompareButton = function () {
        return this._slides[0].widget.widgetContent.sourceName;
    };
    SliderWidgetContent.prototype.getOtaPriceCompareSegment = function () {
        return this._isOtaPriceCompareSWActivated
            ? ExperimentSegment.get('ota-price-compare', ['old-1', 'new', 'old-2', 'new'])
            : null;
    };
    SliderWidgetContent.prototype.createButton = function (container, resizeCb) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var stylesButton, templateButton;
        /* ВНИМАНИЕ! Если будут недовольные отели, которые не хотят кешбэчную мобильную кнопку,
         * то можно просто поменять условие на this.getPromoWidgetIndex() === 0;
         * Тогда кому виджет кэшбека важен и стоит на первом месте - будут видеть новую зеленую кнопку,
         * а кто намеренно его задвигает подальше - увидят старую кнопку "Скидки".
         * НО! Это ухудшит конверсионность, поэтому я бы этого не делал вопреки желаниям отелей.
         */
        var newPromoButtonActivated = this.getCashbackWidgetIndex() !== -1;
        var priceCompareSegment = this.getOtaPriceCompareSegment();
        var swPriceCompareVisible = priceCompareSegment !== null && priceCompareSegment === 'new';
        if (swPriceCompareVisible) {
            stylesButton = this.updateStyles(this._widget.behavior.styles, require('./Button/PriceCompareTemplateButton.scss').toString());
            templateButton = require('./Button/PriceCompareTemplateButton.html');
        }
        else {
            if (this._isOtaPriceCompareSWActivated && this._slides.length <= 1) {
                this.trackEvent('preview');
                return null;
            }
            stylesButton = this.updateStyles(this._widget.behavior.styles, require('./Button/TemplateButton.scss').toString());
            templateButton = require('./Button/TemplateButton.html');
        }
        var element = this.processButtonTemplate(templateButton);
        if (swPriceCompareVisible) {
            var lang = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.TL) === null || _a === void 0 ? void 0 : _a.SmartWidget) === null || _b === void 0 ? void 0 : _b._config) === null || _c === void 0 ? void 0 : _c.language;
            var labelText = element.querySelector('#swPcLabelText');
            var sourceNameText = element.querySelector('#swPcLabelSourceName');
            if (lang) {
                var sourceName = this.getSourceNameForPriceCompareButton();
                if (lang.toLowerCase() === 'ru' || lang.toLowerCase() === 'ru-ru') {
                    labelText.innerText = 'Дешевле, чем на';
                    sourceNameText.innerText = sourceName;
                }
                else {
                    labelText.innerText = 'Pay less, than on';
                    sourceNameText.innerText = sourceName;
                }
            }
        }
        else if (newPromoButtonActivated) {
            var lang = (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.TL) === null || _d === void 0 ? void 0 : _d.SmartWidget) === null || _e === void 0 ? void 0 : _e._config) === null || _f === void 0 ? void 0 : _f.language;
            var btnLabel = element.querySelector('.sw-button__label');
            if (lang) {
                if (lang.toLowerCase() === 'ru' || lang.toLowerCase() === 'ru-ru') {
                    btnLabel.innerText = 'КЕШБЭК';
                }
                else {
                    btnLabel.innerText = 'CASHBACK';
                }
            }
        }
        container.appendChild(this.processStyles(stylesButton));
        container.appendChild(element);
        var iconKind = this._widget.content.iconKind;
        var button = container.querySelector('[button]');
        // Защитный IF от встроенных иконок, которые не надо запрашивать с бекенда в случае сравнения цен
        if (!swPriceCompareVisible) {
            this.processIcon(button.querySelector('[icon]'), iconKind);
        }
        // После добавления в DOM
        setTimeout(function () {
            if (resizeCb) {
                resizeCb(SliderState.Button, {
                    width: BUTTON_WIDTH
                });
            }
            // Раскрываем кнопку
            setTimeout(function () {
                if (_this._needButtonAnimation) {
                    HtmlUtil.toggleClass(button, '-open', true);
                    if (resizeCb) {
                        resizeCb(SliderState.Button, {
                            width: BUTTON_OPENED_WIDTH
                        });
                        var animationEndHandler_1 = function () {
                            resizeCb(SliderState.Button, {
                                width: button.getBoundingClientRect().width + "px"
                            });
                            button.removeEventListener('animationend', animationEndHandler_1);
                        };
                        button.addEventListener('animationend', animationEndHandler_1);
                    }
                }
            }, 2000);
            _this.trackEvent('preview');
        });
        button.querySelector('[opener]').addEventListener('click', function () {
            _this.toggleSlider(container, resizeCb);
        });
        return element;
    };
    SliderWidgetContent.prototype.createSlider = function (container, templateMode, resizeCb, hideCb) {
        var _this = this;
        var stylesSlider = require('./TemplateSlider.scss'), templateSlider = require('./TemplateSlider.html'), element = this.processSliderTemplate(templateSlider, templateMode), links = {};
        container.appendChild(this.processStyles(stylesSlider));
        container.insertBefore(element, this._buttonElement);
        this._sliderList = element.querySelector('[slider-list]');
        this._sliderBar = element.querySelector('[slider-bar]');
        var otaPriceCompareSegmentA = this.getOtaPriceCompareSegment();
        var pcNotVisible = otaPriceCompareSegmentA !== 'new';
        for (var i = 0; i < this._slides.length; i++) {
            var templateKind = this._slides[i].widget.widgetType === 'Comparer'
                ? TemplateKind.Comparer
                : TemplateKind.Static;
            var content = this._slides[i].render(templateKind, templateMode, function () {
                _this.trackEvent('submit');
            }, function () {
                if (hideCb) {
                    hideCb();
                    _this.trackEvent('close');
                }
                else {
                    _this.toggleSlider(container, resizeCb);
                }
            }, true);
            var elements = Array.prototype.slice.call(content.children);
            for (var index in elements) {
                if (!elements.hasOwnProperty(index)) {
                    continue;
                }
                var element_1 = elements[index];
                if (element_1.nodeName === 'STYLE') {
                    this._dynamicStyles.push(element_1.textContent);
                }
                else if (element_1.nodeName === 'LINK') {
                    var href = element_1.getAttribute('href');
                    if (!links[href]) {
                        links[href] = element_1;
                    }
                }
                else {
                    var slide = document.createElement('div');
                    slide.className = 'sw-slider__slide';
                    slide.setAttribute('slide', i.toString());
                    slide.appendChild(element_1);
                    this._sliderList.appendChild(slide);
                }
            }
            var point = document.createElement('div');
            point.className = 'sw-slider__point';
            point.setAttribute('slider-point', i.toString());
            if (this._sliderBar) {
                this._sliderBar.querySelector('[slider-points]').appendChild(point);
            }
        }
        this._dynamicStyleElement = document.createElement('style');
        container.appendChild(this._dynamicStyleElement);
        if (Object.keys(links).length) {
            var linkElement = document.createElement('div');
            for (var index in links) {
                if (links[index]) {
                    linkElement.appendChild(links[index]);
                }
            }
            container.appendChild(linkElement);
        }
        this.setSlide();
        // После добавления в DOM
        setTimeout(function () {
            if (_this._sliderBar) {
                _this.addSliderEventListeners(templateMode);
            }
        });
        return element;
    };
    SliderWidgetContent.prototype.toggleSlider = function (container, resizeCb) {
        var button = container.querySelector('[button]');
        var bottomIndent = this._behavior.appearance.bottomIndent;
        var buttonLimitHeight = 500 + (bottomIndent || 0);
        this._sliderOpened = !this._sliderOpened;
        var slider = container.querySelector('.sw-slider');
        if (!slider) {
            slider = this.createSlider(container, TemplateMode.Mobile, resizeCb);
        }
        slider.style.display = this._sliderOpened ? 'block' : 'none';
        if (this._sliderOpened) {
            this.setSliderHeight();
            this._needButtonAnimation = false;
            if (window.innerHeight < buttonLimitHeight) {
                HtmlUtil.toggleClass(button, '-hide');
            }
            else {
                HtmlUtil.toggleClass(button, '-close');
                HtmlUtil.toggleClass(button, '-open', true);
            }
            this.setStyle();
            if (resizeCb) {
                resizeCb(SliderState.Slider, {
                    width: SLIDER_WIDTH
                });
            }
            this.trackEvent('show');
        }
        else {
            HtmlUtil.toggleClass(button, '-hide', false);
            HtmlUtil.toggleClass(button, '-open', false);
            if (resizeCb) {
                resizeCb(SliderState.Button, {
                    width: BUTTON_WIDTH
                });
            }
            this.trackEvent('close');
        }
    };
    SliderWidgetContent.prototype.addSliderEventListeners = function (templateMode) {
        var _this = this;
        var toPrev = function () {
            if (!_this._slides.length) {
                return;
            }
            _this._lastSlideIndex = _this._currentSlideIndex;
            _this._currentSlideIndex = _this._currentSlideIndex > 0 ? --_this._currentSlideIndex : _this._slides.length - 1;
            _this.animateSlide(SlideDirection.Right, _this._lastSlideIndex, _this._currentSlideIndex);
            _this.trackEvent('swipe');
        };
        var toNext = function () {
            if (!_this._slides.length) {
                return;
            }
            _this._lastSlideIndex = _this._currentSlideIndex;
            _this._currentSlideIndex = _this._currentSlideIndex < _this._slides.length - 1 ? ++_this._currentSlideIndex : 0;
            _this.animateSlide(SlideDirection.Left, _this._lastSlideIndex, _this._currentSlideIndex);
            _this.trackEvent('swipe');
        };
        var xTouchStart = null;
        this._sliderBar.addEventListener('click', function (e) {
            var target = e.target;
            if (!target) {
                return;
            }
            if (target.hasAttribute('slider-point')) {
                var slideIndex = parseInt(target.getAttribute('slider-point'), 10);
                _this.setSlide(slideIndex);
                _this.trackEvent('swipe');
            }
            if (target.hasAttribute('slider-arrow-left')) {
                toPrev();
            }
            if (target.hasAttribute('slider-arrow-right')) {
                toNext();
            }
        });
        this._sliderList.addEventListener('touchstart', function (e) {
            xTouchStart = e.touches[0].clientX;
        });
        this._sliderList.addEventListener('touchmove', function (e) {
            if (!xTouchStart) {
                return;
            }
            var diff = xTouchStart - e.touches[0].clientX;
            if (Math.abs(diff) < 30) {
                return;
            }
            if (diff > 0) {
                toNext();
            }
            else {
                toPrev();
            }
            xTouchStart = null;
        });
    };
    SliderWidgetContent.prototype.setSlide = function (index) {
        if (index === void 0) { index = this._currentSlideIndex; }
        this._lastSlideIndex = this._currentSlideIndex;
        this._currentSlideIndex = index;
        this.animateSlide(this._lastSlideIndex < this._currentSlideIndex ? SlideDirection.Left : SlideDirection.Right, this._lastSlideIndex, this._currentSlideIndex);
    };
    SliderWidgetContent.prototype.updateBar = function () {
        if (!this._sliderBar) {
            return;
        }
        var points = this._sliderBar.querySelectorAll('[slider-point]'), arrowLeft = this._sliderBar.querySelector('[slider-arrow-left]'), arrowRight = this._sliderBar.querySelector('[slider-arrow-right]');
        if (!points.length) {
            return;
        }
        for (var i = 0; i < points.length; i++) {
            HtmlUtil.toggleClass(points[i], '-active', i === this._currentSlideIndex);
        }
        HtmlUtil.toggleClass(arrowLeft, '-hide', this._currentSlideIndex === 0);
        HtmlUtil.toggleClass(arrowRight, '-hide', points.length - 1 === this._currentSlideIndex);
    };
    SliderWidgetContent.prototype.animateSlide = function (direction, from, to) {
        var _this = this;
        clearTimeout(this._animationId);
        var slides = this._sliderList.querySelectorAll('[slide]');
        var slideFrom = slides[from], slideTo = slides[to];
        this.updateBar();
        if (from === to) {
            HtmlUtil.toggleClass(slideTo, '-active');
            HtmlUtil.toggleClass(slideTo, '-no-animate');
            HtmlUtil.transform(slideTo, 'translateX(0%)');
            this.setStyle();
            this._animationId = window.setTimeout(function () {
                HtmlUtil.toggleClass(slideTo, '-no-animate', false);
            });
            return;
        }
        HtmlUtil.transform(slideFrom, 'translateX(0%)');
        HtmlUtil.toggleClass(slideFrom, '-active', false);
        HtmlUtil.transform(slideTo, direction === 'left' ? 'translateX(100%)' : 'translateX(-100%)');
        this._animationId = window.setTimeout(function () {
            HtmlUtil.toggleClass(slideTo, '-active', true);
            HtmlUtil.transform(slideFrom, direction === 'left' ? 'translateX(-100%)' : 'translateX(100%)');
            HtmlUtil.transform(slideTo, 'translateX(0%)');
            _this.setStyle();
        }, 150);
        this.updateSliderHeight();
    };
    SliderWidgetContent.prototype.setSliderHeight = function () {
        var _this = this;
        var slides = this._sliderList.querySelectorAll('[slide]');
        var height;
        for (var i = 0; i < slides.length; i++) {
            if (this._dynamicStyles[i]) {
                this._dynamicStyleElement.innerHTML = this._dynamicStyles[i];
            }
            if (!height || height < slides[i].clientHeight) {
                height = slides[i].clientHeight;
            }
        }
        this._dynamicStyleElement.innerHTML = this._dynamicStyles[0];
        // Некоторые браузеры рендерят с задержкой, высота может быть нулевой
        if (height === 0) {
            setTimeout(function () { return _this.setSliderHeight(); }, 100);
            return;
        }
        this._sliderList.style.height = height + 'px';
        this.updateSliderHeight();
    };
    SliderWidgetContent.prototype.setStyle = function () {
        if (!this._dynamicStyles[this._currentSlideIndex]) {
            return;
        }
        this._dynamicStyleElement.innerHTML = this._dynamicStyles[this._currentSlideIndex];
    };
    SliderWidgetContent.prototype.updateSliderHeight = function () {
        var _this = this;
        if (!document.fonts) {
            return;
        }
        var slides = this._sliderList.querySelectorAll('[slide]');
        var currentSliderHeight = slides[this._currentSlideIndex].clientHeight;
        document.fonts.onloadingdone = function () {
            var newSliderHeight = slides[_this._currentSlideIndex].clientHeight;
            if (currentSliderHeight === newSliderHeight) {
                return;
            }
            _this._sliderList.style.height = newSliderHeight + 'px';
        };
    };
    SliderWidgetContent.prototype.processSliderTemplate = function (template, templateMode) {
        var html = Templater.parse(template, {
            hasBar: this._slides.length > 1,
            align: this._behavior.appearance.position.toLocaleLowerCase(),
            templateMode: templateMode.toLowerCase()
        });
        return this.processTemplate(html);
    };
    SliderWidgetContent.prototype.processButtonTemplate = function (template) {
        var html = Templater.parse(template, {
            text: this._widget.content.text,
            align: this._behavior.appearance.position.toLocaleLowerCase()
        });
        return this.processTemplate(html);
    };
    return SliderWidgetContent;
}(WidgetContent));
export { SliderWidgetContent };
